import React, { ChangeEvent, FC, useEffect, useState } from "react";
import {
  QuestionConfigDetailDto,
  QuestionConfigTranslationDto,
} from "@green0meter/api-client";

import { StyledTextField } from "../../QuestionTypeEditor.styled";

import { useQuestionEditorStore } from "@components/main/questions/QuestionEditor";
import { DEFAULT_DATE_FORMAT } from "@constants";

interface DateInput {
  questionConfig: QuestionConfigDetailDto;
  setQuestionConfig: (questionConfig: QuestionConfigDetailDto) => void;
}

const DateInput: FC<DateInput> = ({ questionConfig, setQuestionConfig }) => {
  const { language } = useQuestionEditorStore();
  const [translation, setTranslation] = useState<QuestionConfigTranslationDto>();

  const handleChangePlaceholder = (e: ChangeEvent<HTMLInputElement>): void => {
    if (questionConfig) {
      setQuestionConfig({
        ...questionConfig,
        translations: questionConfig.translations.map((translation) =>
          translation.language === language
            ? { ...translation, placeholder: e.target.value }
            : translation,
        ),
      });
    }
  };

  useEffect(() => {
    if (questionConfig) {
      const currentTranslation = questionConfig.translations.find(
        (translation) => translation.language === language,
      );

      setTranslation(currentTranslation);
    }
  }, [questionConfig, language]);

  return questionConfig ? (
    <StyledTextField
      value={translation?.placeholder || DEFAULT_DATE_FORMAT}
      onChange={handleChangePlaceholder}
      variant="filled"
      fullWidth
    />
  ) : null;
};

export default DateInput;
